export default "/048cb1f2b29308e18768c65cfd51e426596a830c/837e258702481769ad64684ae735d0c9.svg";